export default {
  UPDATE: 'STAFF/UPDATE'
};
